var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("job-published-pasts", {
    attrs: {
      "data-test": "job-published-pasts",
      title: "過去の求人情報プレビュー",
      "component-name": "job-published-job",
      "recent-past-objects": _vm.recentPastJobs,
      "past-objects": _vm.pastJobs,
    },
    scopedSlots: _vm._u([
      {
        key: "head",
        fn: function () {
          return [
            _c("tr", { attrs: { "data-test": "head" } }, [
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        求人ID\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        管理用求人名\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        求人名\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        掲載期間\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        掲載サイズ\n      "),
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "boss-table-head-center" }, [
                _vm._v("\n        プレビュー\n      "),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }